import {
  Box,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Stack,
  Typography
} from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import ServerPagination, { IPaginator } from '../../../components/Common/PaginatorServer'
import { LocalesPerfilImp } from '.'
import { useNavigate } from 'react-router'
import { PropsPI } from './TablaLocales'

const headers = [
  { key: 'local', label: 'Local' },
  { key: 'whpp', label: 'Whatsapp' },
  { key: 'contrato', label: 'Contrato' },
  { key: 'contratoFechaFin', label: 'Fecha Fin Contrato' }
]

/* eslint-disable react/prop-types */
const CardsLocales: React.FC<PropsPI> = ({ locales, loading, paginator, formatDate }) => {
  const navigate = useNavigate()
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <>
      <Stack spacing={2}>
        {locales.map((l: LocalesPerfilImp) => (
          <Card
            key={l.clienteCodigoLocal}
            onClick={() => navigate(`/admin-local/${l.clienteCodigoLocal}`)}
            sx={{
              cursor: 'pointer',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              '&:hover': { boxShadow: 3 }
            }}
          >
            <CardContent sx={{ pb: '12px !important' }}>
              <Typography fontWeight="bold" fontSize={16} mb={1}>
                {`${l.clienteNombre} (${l.clienteCodigoLocal})`}
              </Typography>

              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Typography variant="body2" color="text.secondary" minWidth={90}>
                  Whatsapp:
                </Typography>
                <Chip
                  icon={<WhatsAppIcon sx={{ fontSize: 14 }} />}
                  label={l.clienteWhatsapp}
                  size="small"
                  component="a"
                  href={`https://wa.me/${l.clienteWhatsapp.replace(/\D/g, '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  clickable
                  onClick={(e) => e.stopPropagation()}
                  sx={{
                    fontSize: 12,
                    bgcolor: 'success.50',
                    color: 'success.dark',
                    border: 'none',
                    cursor: 'pointer',
                    '& .MuiChip-icon': { color: 'success.dark' }
                  }}
                />
              </Stack>

              <Stack direction="row" spacing={1} mb={0.5}>
                <Typography variant="body2" color="text.secondary" minWidth={90}>
                  Contrato:
                </Typography>
                <Typography variant="body2">{`${l.productoNombre} (${l.idContrato})`}</Typography>
              </Stack>

              <Stack direction="row" spacing={1}>
                <Typography variant="body2" color="text.secondary" minWidth={90}>
                  Fecha Fin:
                </Typography>
                <Typography variant="body2">{formatDate(l.contratoFechaFin)}</Typography>
              </Stack>
            </CardContent>
          </Card>
        ))}
        <ServerPagination component={'td'} label="Locales por página" paginator={paginator} />
      </Stack>
    </>
  )
}

export default CardsLocales
